export default __webpack_public_path__ + "static/media/avalanche-avax-logo.a3f3731d.svg";